import React from 'react';
import classnames from 'classnames';
import { Icon, makeStyles, Icons } from '~/lib/bn-material-ui';
import { captureException } from '@sentry/browser';
import { DateTime } from 'luxon';

const useStyles = makeStyles(({ palette }) => {
  return {
    icon: {
      color: palette.blue[40],
    },
    iconWarning: {
      color: palette.yellow[30],
    },
  };
});

// Ideally we should reuse the same component here and in ui-orders.order-list-item-status.js
export function OrderStatusIcon({ order, hasOverFill }) {
  const styles = useStyles();
  if (!order) {
    return null;
  }

  const classList = classnames(
    styles.icon,
    hasOverFill ? styles.iconWarning : '',
  );

  const extraStyles = { fontSize: '1rem', marginBottom: '-0.2rem' };

  const { state, type } = order.properties;

  let status = state === 'ready' ? type : state;

  switch (status) {
  case 'draft':
    return <Icon style={extraStyles} className='far fa-calendar-edit' />;
  case 'scheduled':
    if (hasOverFill) {
      return <Icons.WarningRounded style={extraStyles} className={classList}/>;
    }
    return <Icons.Event style={extraStyles} className={classList}/>;
  case 'suggestion':
    return <Icons.AutoAwesome style={extraStyles} className={classList}/>;
  case 'request':
    return <Icons.PriorityHigh style={extraStyles} className={classList}/>;
  case 'delivered':
    return <Icons.EventAvailable style={extraStyles} className={classList}/>;
  case 'not-delivered':
    return <Icons.EventBusy style={extraStyles} className={classList}/>;
  case 'closed':
    return <Icons.Close style={extraStyles} className={classList}/>;
  default:
    captureException(`OrderStatusIcon | Unknown order status: ${status} from orderId: ${order.getLinkByRel('self')?.href}`);
    return null;
  }
}

export function getOrderStatusText({ order, deliveryDate }) {
  if (!order?.properties) {
    return '';
  }

  const { state, type } = order.properties;
  let status = state === 'ready' ? type : state;

  switch (status) {
  case 'scheduled':
    const today = DateTime.now().toISODate();
    const deliveryDay = DateTime.fromISO(deliveryDate || order.properties.deliveryDate).toLocal().toISODate();
    if (deliveryDay < today) {
      return 'Past Order';
    }
    if (deliveryDay > today) {
      return 'Scheduled Order';
    }
    return 'Today\'s Order';
  case 'draft':
    return 'Draft';
  case 'suggestion':
    return 'Suggestion';
  case 'request':
    return 'Request';
  case 'delivered':
    return 'Delivered';
  case 'not-delivered':
    return 'Not Delivered';
  case 'closed':
    return 'Closed';
  default:
    captureException(`OrderDateText | Unknown order status: ${status} from orderId: ${order.getLinkByRel('self')?.href}`);
    return status;
  }
}
